"use client";

import { ChevronDownIcon } from "@vetty/icons";
import classNames from "classnames";
import { useState, type ReactNode } from "react";
import styles from "./SidebarNavGroup.module.scss";

export const SidebarNavGroup = ({
  children,
  label,
  collapsible = false,
  defaultOpen = true,
}: {
  children: ReactNode;
  label: string;
  collapsible?: boolean;
  defaultOpen?: boolean;
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className={styles["comp"]}>
      <button
        type="button"
        className={classNames(
          styles["comp__label"],
          collapsible && styles["comp__label--collapsible"]
        )}
        onClick={collapsible ? () => setIsOpen((open) => !open) : undefined}
      >
        <span>{label}</span>
        {collapsible && (
          <ChevronDownIcon
            style={{ width: 16, height: 16 }}
            className={classNames(
              styles["comp__chevron"],
              isOpen && styles["comp__chevron--open"]
            )}
          />
        )}
      </button>
      {isOpen && <div className={styles["comp__items"]}>{children}</div>}
    </div>
  );
};
